export const polytradeAddress = "0x692AC1e363ae34b6B489148152b12e2785a3d8d6";
export const condoPolygonTreasury =
  "0x4bF52ff02cc24ecD3d0e8E104f178647893Bd310";
